import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Dialog,
  Zoom,
  Switch,
  Grid,
  Badge,
  keyframes,
  Button,
  useMediaQuery,
  DialogTitle,
  DialogContent,
  Paper,
  FormControlLabel,
  DialogActions,
  useTheme
} from '@mui/material';
import { Icon } from '@iconify/react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import dayjs from 'dayjs';
import * as yup from 'yup';
import {
  Email as EmailIcon,
  Close as CloseIcon,
  Check as CheckIcon
} from '@mui/icons-material';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import {
  autoGeneratedTripsAction,
  clearScheduleData,
  filterVehicleAction,
  getExcelAction,
  getPDFExcelReport,
  publishTripsAction,
  sendAgentNotification,
  sendwhatsappAction,
  setFilter,
  switchTripsAction,
  tourAgentDropdown
} from '../../../redux/reducer/autoPlannerSlices/autoGenerateSlice';
import constant from '../../../../../utils/constants';
import {
  capitalizeFirstLetter,
  getEpochFromDateStart,
  getEpochToDate,
  getTomorrowEpoch,
  useAbort
} from '../../../../../utils/commonFunctions';
import CustomDateCalendar from '../../../../../common/components/customized/customcalendar/CustomCalendar';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import CustomSelect from '../../../../../common/components/customized/customselect/CustomSelect';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import UpdateScheduleTrip from './UpdateScheduleTrip';
import {
  autoPlannerImportTripsAction,
  autoPlannerRoutesAction
} from '../../../redux/reducer/autoPlannerSlices/autoplanner';
import ScheduledSic from './components/ScheduledSic';
import ScheduledTsic from './components/ScheduledTsic';
import ScheduledPvt from './components/ScheduledPvt';
import ScheduledGrp from './components/ScheduledGrp';
import ExcelIcon from '../../../assets/images/excel.png';
import CustomTab from '../../../../../common/components/tab/CustomTab';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomSwitch from '../../../../../common/components/switch/CustomSwitch';
import ExcelView from './components/ExcelView';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import * as XLSX from 'xlsx';
import {
  asyncSuccessAction,
  clearAsyncSuccess,
  downloadSummaryAction
} from '../../../redux/reducer/autoPlannerSlices/tourSummary';
import { getMyProfileAction } from '../../../../../common/redux/reducer/commonSlices/myProfileSlice';
import { Bell, CheckCircle, Loader } from 'lucide-react';
import './AutoGenerateView.scss';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';
import { CheckCircleIcon } from 'lucide-react';
import {
  createConnection,
  updateData
} from '../../../../../common/redux/reducer/commonSlices/websocketSlice';
import ErrorDialog from '../bookings/components/ErrorDialog';
import CustomDialogGrid from '../../../../../common/components/customdialogGrid/CustomDialogGrid';
import ScheduledRLR from './components/ScheduledRLR';

interface Row {
  id: number;
  agentname: string;
  guestname: string;
  fromlocation: string;
  tolocation: string;
  startDateTime: string;
  adultcount: number;
  childcount: number;
  driver: string;
  tripType: string;
  groupId: string;
  trip_id: number;
}

interface Params {
  email: string;
}

const AutoGenerateView = () => {
  const [isUpdate, setIsUpdate] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<Row | null>(null);
  const [isDialog, setIsDialog] = useState('');
  // const [publishLoading, setPublishLoading] = useState(false);
  const [searchPayload, setSearchPayload] = useState<any>('');
  const [timeZone, setTimeZone] = useState<string>('UTC');
  const [drawer, setDrawer] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [triggerCount, setTriggerCount] = useState<number>(0);
  const [alertClose, setAlertClose] = useState<boolean>(false);
  const [viewDialogGrid, setViewDialogGrid] = useState<boolean>(false);
  const [importFile, setImportFile] = useState<any>(null);
  const [excelRows, setExcelRows] = useState<[] | any>([]);
  const [errorShow, setErrorShow] = useState<boolean>(false);
  const [openConnectionError, setOpenConnectionError] = useState<boolean>(false);
  const [excelDatas, setExcelDatas] = useState<any>(null);
  const [uploading, setUploading] = useState<boolean>(false);
  const [INexcelRows, setINExcelRows] = useState<[] | any>([]);
  const [jsonDATA, setJsonData] = useState<any | []>([]);
  const [scheduleDate, setScheduleDate] = useState<number>(0);
  const [pageSize, setPageSize] = useState(20);
  const [importFilePickup, setImportFilePickup] = useState<any>(null);
  const [pageNo, setPageNo] = useState(1);
  const [expanded, setExpanded] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [view, setView] = useState<boolean>(false);
  const [sortModel, setSortModel] = useState<any>([]);
  const [tabValue, setTabValue] = useState(0);
  const [filteerCount, setFilteerCount] = useState(0);
  const [tripMode, setTripMode] = useState<string>('ALL');
  const [checked, setChecked] = useState(false);
  const [breadcrumbs, setBreadCrumbs] = useState<any>({});
  const [tripPayload, setTripPayload] = useState({ pageNo, pageSize });
  const [agent, setAgent] = useState('');
  const [guest, setGuest] = useState('');
  const [tour, setTour] = useState('');
  const [switchType, setSwitchType] = useState('All');
  const [whatsappEnabled, setWhatsappEnabled] = useState(false);
  const [emailEnabled, setEmailEnabled] = useState(false);
  const [vehicle, setVehicle] = useState('');
  const [vehicles, setVehicles] = useState<any | null>(null);
  const [initialLoad, setInitialLoad] = useState<boolean>(true);
  const [zone, setZone] = useState<boolean>(true);
  const [generateClicked, setGenerateClicked] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const [status, setStatus] = useState('idle');
  const [callAsync, setCallAsync] = useState(false);
  const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);
  const [importButtonDisable, setImportButtonDisable] = useState<boolean>(true);
  const [scheduledPayload, setScheduledPayload] = useState({
    autoplannerID: scheduleDate,
    pageNo: pageNo,
    pageSize: pageSize
  });
  const [publishWhatsapp, setPublishWhatsapp] = useState(false);
  const abortController = useRef<AbortController | null>(null);

  const createAbort = useAbort();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { date } = location.state || {};

  const [payloadState, setPayloadState] = useState<any>();
  const reportData = useAppSelector(state => state.AutoGeneratedTrip);
  const notifyAgent = useAppSelector(state => state.AgentNotification);
  const publishLoading = useAppSelector(state => state.publishBookings.isLoading);
  const { data, isLoading: SICLoad } = useAppSelector(state => state.switchTrip);
  const { data: excelData } = useAppSelector(state => state.getExcel);
  const Agents = useAppSelector(state => state.autoPlannerAgent.data || []);
  const Vehicle = useAppSelector(state => state.vehicleDropdown.data || []);
  const Routes = useAppSelector(state => state.autoPlannerRoutes.data || []);
  const { isLoading } = useAppSelector(state => state.autoPlannerMail);
  const { isLoading: load } = useAppSelector(state => state.importAutoPlannerTrip);
  const { isLoading: excelLoad } = useAppSelector(state => state.getExcel);
  const { data: roledata } = useAppSelector(state => state.auth);
  const { connection, data: excelLoader } = useAppSelector(state => state.websocket);
  const { data: dropdown } = useAppSelector(state => state.dropdownAgentTour);
  const sendwhatsapp = useAppSelector(state => state.sendwhatsapp);
  const error: any = useAppSelector(
    state => state.importAutoPlannerTrip.data || [{ invalidExcelRows: [] }]
  );

  const { isLoading: downloadLoader } = useAppSelector(
    (state: any) => state.downloadSummary
  );

  const {
    isLoading: asynSuccessLoading,
    data: asyncSuccessData,
    error: asyncSuccessError
  } = useAppSelector(state => state.asyncSuccess);

  let roletype = roledata?.role;
  const APsuperAdmin = roletype === 'ROLE_AUTOPLANNER_ADMIN';
  const APoperator = roletype === 'ROLE_OPERATOR';

  const profileData = useAppSelector(state => state.myProfile.data);
  const { email } = useAppSelector(state => state.myProfile.data || { email: '' });
  const { data: loginData } = useAppSelector(state => state.auth);

  const APagent = roletype === 'ROLE_AGENT';
  const APsubAgents = roletype === 'ROLE_SUB_AGENT';

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const schema = yup.object().shape({
    reportDate: yup.string().required('Enter date')
  });

  const agentNames =
    dropdown?.agents?.map((value: string) => ({
      id: value,
      label: capitalizeFirstLetter(value)
    })) || [];

  const vehicleNumber =
    Vehicle?.map((value: any) => ({
      id: value,
      label: value?.toUpperCase()
    })) || [];

  // for download file to email
  const mailSchema = yup.object().shape({
    email: yup
      .string()
      .required('Enter Email ID')
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, 'Enter Valid Email ID')
      .email('Enter Email ID')

    // document: yup.string().required('Select document type')
  });

  const { control, setValue, clearErrors, handleSubmit } = useForm({
    resolver: yupResolver(schema)
  });

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const {
    control: filterControl,
    getValues: filterGetValues,
    reset: filterReset,
    watch: filterWatch
  } = useForm({});

  const {
    control: mailControl,
    setValue: setMailValues,
    handleSubmit: mailSubmit,
    clearErrors: mailClearErrors
  } = useForm({
    resolver: yupResolver(mailSchema)
  });

  const isMd = useMediaQuery('(max-width:515px)');
  const isXs = useMediaQuery('(max-width:415px)');
  const tripisXs = useMediaQuery('(max-width:615px)');
  const isShare = useMediaQuery('(max-width:595px)');

  const formatDateFromEpoch = (epoch: number | null) => {
    return epoch ? dayjs.unix(epoch).format('YYYY-MM-DD') : '';
  };

  const handleClose = () => {
    setIsDialog('');
    setShowSuccessAnimation(false);
    setEmailEnabled(false);
    setWhatsappEnabled(false);
    dispatch(updateData({ progress: 'FAILED', date: 'Loading', action: 'ExcelUpload' }));
    if (connection) connection.close();
  };

  const GetTomorrowDate = (epochTime: number) => {
    setScheduleDate(date ? date : epochTime);
    if (epochTime) {
      const payload = {
        ...scheduledPayload,
        autoplannerID: epochTime,
        pageNo: pageNo,
        pageSize: pageSize
      };
      setScheduledPayload(payload);
      setValue('reportDate', formatDateFromEpoch(epochTime));
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  let tripList = ['SIC', 'TSIC', 'PVT', 'GRP', 'RLR'];

  // funtion for import trips
  const handleUpload = () => {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.accept = '.xlsx,.xls';

    inputElement.onchange = (event: any) => {
      const file = event.target.files[0];
      if (!file) return;

      const allowedExtensions = ['xlsx', 'xls'];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
        dispatch(
          updateToast({
            show: true,
            message: 'Please upload a valid Excel file (.xlsx or .xls)',
            severity: 'warning'
          })
        );
        setImportFile(null);
        return;
      }

      const fileReader = new FileReader();
      fileReader.onload = (event: any) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        setExcelDatas(jsonData);

        const tomorrowEpoch = getTomorrowEpoch('UTC');
        const tomorrowDate = new Date(tomorrowEpoch * 1000);

        const formattedTomorrow = tomorrowDate
          .toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: '2-digit'
          })
          .replace(/ /g, '-')
          .replace('Sept', 'Sep');

        const isValid = jsonData.slice(1).every((row: any) => {
          const cellValue = row[1]?.toString().trim();
          return cellValue === formattedTomorrow;
        });

        if (!isValid) {
          dispatch(
            updateToast({
              show: true,
              message: "Invalid date. Please upload only tomorrow's schedule.",
              severity: 'warning'
            })
          );
          setImportFile(null);
          return;
        }

        // If valid, store the file
        setImportFile(file);
      };

      fileReader.readAsArrayBuffer(file);
    };

    inputElement.click();
  };

  const handleTrip = async (e: any, newValue: any) => {
    setTabValue(newValue);
    switch (newValue) {
      case 0:
        setTripMode('SIC');
        break;
      case 1:
        setTripMode('TSIC');
        break;
      case 2:
        setTripMode('PVT');
        break;
      case 3:
        setTripMode('GRP');
        break;
      case 4:
        setTripMode('RLR');
        break;
      default:
        break;
    }
  };

  const DateLabel = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center'
        }}
      >
        <Icon
          icon='lets-icons:date-today-duotone'
          width='20'
          height='20'
          style={{ color: 'blue', marginRight: '5px' }}
        />
        <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>
          {!scheduleDate ? 'Loading...' : getEpochToDate(scheduleDate, timeZone)}
        </Typography>
      </Box>
    );
  };

  const handlePublish = async () => {
    const payload = {
      date: scheduleDate,
      isMail: emailEnabled ? 1 : 0,
      isWhatsapp: whatsappEnabled ? 1 : 0
    };
    const action = await dispatch(publishTripsAction(payload));
    if (action.type === publishTripsAction.fulfilled.type) {
      setShowSuccessAnimation(true);
      setIsDialog('');
      setTimeout(() => {
        handleClose();
      }, 4000);
    }
  };

  // function for share reports to agent
  const handleShareReport = async () => {
    let payload = {
      recipient: 'ROLE_AGENT',
      date: scheduleDate
    };
    await dispatch(getPDFExcelReport(payload));
    setIsDialog('');
    handleMenuClose();
  };

  const handleDownloadTrip = () => {
    setDrawer(true);
  };

  const handleSendWhatsapp = async () => {
    const payload = {
      autoplannerId: scheduleDate
    };
    await dispatch(sendwhatsappAction(payload));
    setIsDialog('');
  };

  const clearFilter = () => {
    filterReset({
      agentName: '',
      guestName: '',
      tourName: '',
      vehicleNumber: null
    });
    setTripPayload({ pageNo: 1, pageSize: pageSize });
    setPageNo(1);
    setErrorMessage('');
    setFilteerCount(0);
  };

  const createKeyframeAnimations = () => {
    if (document.getElementById('iconAnimationsKeyframes')) return;

    const styleElement = document.createElement('style');
    styleElement.id = 'iconAnimationsKeyframes';
    styleElement.innerHTML = `
    @keyframes bellRing {
      0% { transform: rotate(0); }
      25% { transform: rotate(15deg); }
      50% { transform: rotate(-10deg); }
      75% { transform: rotate(5deg); }
      100% { transform: rotate(0); }
    }
    
    @keyframes checkmarkPop {
      0% { transform: scale(0); opacity: 0; }
      50% { transform: scale(1.2); opacity: 1; }
      100% { transform: scale(1); opacity: 1; }
    }
  `;
    document.head.appendChild(styleElement);
  };

  const createBellKeyframes = () => {
    if (document.getElementById('bellRingKeyframes')) return;

    const styleElement = document.createElement('style');
    styleElement.id = 'bellRingKeyframes';
    styleElement.innerHTML = `
    @keyframes bellRing {
      0% { transform: rotate(0); }
      25% { transform: rotate(15deg); }
      50% { transform: rotate(-10deg); }
      75% { transform: rotate(5deg); }
      100% { transform: rotate(0); }
    }
  `;
    document.head.appendChild(styleElement);
  };

  useEffect(() => {
    createBellKeyframes();

    return () => {
      const styleElement = document.getElementById('bellRingKeyframes');
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, []);

  useEffect(() => {
    createKeyframeAnimations();
    return () => {
      const styleElement = document.getElementById('iconAnimationsKeyframes');
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, []);

  const filterClear = async () => {
    clearFilter();
    setFilteerCount(0);
    const payload = {
      ...searchPayload,
      autoplannerID: scheduleDate,
      tripMode: tripMode,
      PageNo: 1,
      PageSize: payloadState.pageSize
      // searchFor: breadcrumbs.filter ? breadcrumbs.filter : searchPayload.searchFor
    };
    if (expanded) {
      setAgent('');
      setGuest('');
      setTour('');
      setVehicle('');

      if (tripMode === 'PVT' || tripMode === 'GRP') {
        dispatch(autoGeneratedTripsAction(payload));
      }
      if (tripMode === 'ALL') {
        dispatch(getExcelAction(payload));
      } else if (checked) {
        await dispatch(autoGeneratedTripsAction(payload));
      } else {
        await dispatch(switchTripsAction(payload));
      }
    }
    if (!expanded) {
      dispatch(filterVehicleAction(payload));
    }
  };

  //function for sending mail
  const sendMail = async (params: Params) => {
    const payloadMail = {
      recipient: roletype,
      date: scheduleDate,
      mail: params.email
    };
    await dispatch(getPDFExcelReport(payloadMail));
    setDrawer(false);
    // setMailValues('document', '');
    mailClearErrors('email');
  };

  const configuredRoute =
    [...(new Set(dropdown?.tours) as any)]?.map((value: string, index: any) => ({
      id: value,
      label: value
    })) || [];

  const handleToggle = async () => {
    setExpanded(!expanded);
    const payload = {
      autoplannerID: scheduleDate,
      tripMode: tripMode,
      PageNo: 1,
      PageSize: 10,
      searchFor: breadcrumbs.filter
    };

    if (!expanded) {
      dispatch(filterVehicleAction(payload));
    }
  };

  const handleSheetDownload = async () => {
    const payload = {
      date: scheduleDate,
      mode: ''
    };
    const URL = await dispatch(downloadSummaryAction(payload));
    const fileUrl = URL?.payload?.data;
    if (fileUrl) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', 'Autoplanner_Schedule.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const SuccessAnimation = () => (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        animation: 'fadeIn 0.5s ease-in-out',
        '@keyframes fadeIn': {
          '0%': { opacity: 0 },
          '100%': { opacity: 1 }
        }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          bottom: '10%',
          left: '-100px',
          animation: 'rocketFly 3s ease-out forwards',
          '@keyframes rocketFly': {
            '0%': {
              transform: 'translateX(0) translateY(0) rotate(-45deg) scale(1)',
              opacity: 0
            },
            '10%': {
              opacity: 1
            },
            '50%': {
              transform: 'translateX(50vw) translateY(-30vh) rotate(-30deg) scale(1.5)'
            },
            '80%': {
              transform: 'translateX(80vw) translateY(-60vh) rotate(-15deg) scale(2)'
            },
            '100%': {
              transform: 'translateX(120vw) translateY(-80vh) rotate(0deg) scale(2.5)',
              opacity: 0
            }
          }
        }}
      >
        <RocketLaunchIcon
          sx={{
            fontSize: 80,
            color: '#3b82f6',
            filter: 'drop-shadow(0 0 20px rgba(59, 130, 246, 0.8))'
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            right: '100%',
            width: 150,
            height: 8,
            background:
              'linear-gradient(90deg, rgba(255,165,0,0.8) 0%, rgba(255,69,0,0.6) 50%, transparent 100%)',
            borderRadius: 4,
            transform: 'translateY(-50%)',
            animation: 'trailGlow 3s ease-out forwards',
            '@keyframes trailGlow': {
              '0%': {
                width: 0,
                opacity: 0
              },
              '20%': {
                width: 50,
                opacity: 1
              },
              '80%': {
                width: 200,
                opacity: 0.8
              },
              '100%': {
                width: 300,
                opacity: 0
              }
            }
          }}
        />

        {[...Array(8)].map((_, i) => (
          <Box
            key={i}
            sx={{
              position: 'absolute',
              width: 4,
              height: 4,
              backgroundColor: '#ffd700',
              borderRadius: '50%',
              animation: `sparkle${i} 3s ease-out infinite`,
              animationDelay: `${i * 0.2}s`,
              [`@keyframes sparkle${i}`]: {
                '0%': {
                  transform: `translate(${Math.random() * 40 - 20}px, ${
                    Math.random() * 40 - 20
                  }px) scale(0)`,
                  opacity: 0
                },
                '50%': {
                  transform: `translate(${Math.random() * 80 - 40}px, ${
                    Math.random() * 80 - 40
                  }px) scale(1)`,
                  opacity: 1
                },
                '100%': {
                  transform: `translate(${Math.random() * 120 - 60}px, ${
                    Math.random() * 120 - 60
                  }px) scale(0)`,
                  opacity: 0
                }
              }
            }}
          />
        ))}
      </Box>

      <Box
        sx={{
          textAlign: 'center',
          color: 'white',
          animation: 'messageSlideUp 1s ease-out 1.5s forwards',
          opacity: 0,
          transform: 'translateY(50px)',
          '@keyframes messageSlideUp': {
            '0%': {
              opacity: 0,
              transform: 'translateY(50px)'
            },
            '100%': {
              opacity: 1,
              transform: 'translateY(0)'
            }
          }
        }}
      >
        <CheckCircleIcon />
        <Typography
          variant='h3'
          sx={{
            fontWeight: 'bold',
            mb: 1,
            background: 'linear-gradient(45deg, #10b981, #3b82f6)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            animation: 'textGlow 2s ease-in-out infinite alternate',
            '@keyframes textGlow': {
              '0%': {
                textShadow: '0 0 20px rgba(16, 185, 129, 0.5)'
              },
              '100%': {
                textShadow: '0 0 30px rgba(59, 130, 246, 0.8)'
              }
            }
          }}
        >
          Bookings Published Successfully! 🎉
        </Typography>
        <Typography variant='h6' sx={{ opacity: 0.9 }}>
          Your bookings is now available to agents
        </Typography>

        {[...Array(20)].map((_, i) => (
          <Box
            key={i}
            sx={{
              position: 'absolute',
              width: 8,
              height: 8,
              backgroundColor: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57'][
                i % 5
              ],
              animation: `confetti${i} 3s ease-out infinite`,
              animationDelay: `${2 + i * 0.1}s`,
              [`@keyframes confetti${i}`]: {
                '0%': {
                  transform: `translate(${Math.random() * 100 - 50}px, 0) rotate(0deg)`,
                  opacity: 1
                },
                '100%': {
                  transform: `translate(${
                    Math.random() * 200 - 100
                  }px, 300px) rotate(720deg)`,
                  opacity: 0
                }
              }
            }}
          />
        ))}
      </Box>
    </Box>
  );

  const onFilterSubmit = async (data: any) => {
    const payload = {
      ...searchPayload,
      ...tripPayload,
      PageNo: 1,
      PageSize: payloadState.pageSize,
      tripMode: tripMode,
      autoplannerID: scheduleDate,
      agentName: agent,
      guestName: guest,
      tourName: tour,
      vehicleNumber: vehicle
      // searchFor: breadcrumbs.filter
    };
    const pvtPayload = {
      ...searchPayload,
      PageNo: payloadState.pageNo,
      PageSize: payloadState.pageSize,
      tripMode: tripMode,
      autoplannerID: scheduleDate,
      agentName: agent,
      vehicleNumber: vehicle
    };
    const { agentName, guestName, tourName, vehicleNumber } = filterGetValues();

    const values = filterGetValues();

    const filledFieldsCount = Object.values(values).filter(
      value => value !== undefined && value !== null && value !== ''
    ).length;

    setFilteerCount(filledFieldsCount);

    if (!(agentName || guestName || tourName || vehicleNumber)) {
      setErrorMessage('Please fill at least one field!');
      return;
    } else {
      setView(false);
      dispatch(setFilter(true));
      setTripPayload(payload);
    }
    setErrorMessage('');

    if (tripMode === 'PVT' || tripMode === 'GRP') {
      dispatch(autoGeneratedTripsAction(pvtPayload));
    }
    if (tripMode === 'ALL') {
      dispatch(getExcelAction(payload));
    } else if (checked) {
      await dispatch(autoGeneratedTripsAction(payload));
    } else {
      await dispatch(switchTripsAction(payload));
    }
  };

  const onSwitchChange = async (option: string) => {
    setSwitchType(option);
    clearFilter();
    setTripMode('SIC');
    const payloads = {
      autoplannerID: scheduleDate,
      tripMode: option === 'Tour Mode' ? 'SIC' : 'ALL',
      PageNo: 1,
      PageSize: option === 'Tour Mode' ? 20 : 20
    };

    if (option === 'Tour Mode') {
      setTabValue(0);
      setTripMode('SIC');
      await dispatch(switchTripsAction(payloads));
    } else if (option === 'All') {
      setTripMode('ALL');
      await dispatch(getExcelAction(payloads));
    }
  };

  const watchedFields = filterWatch([
    'agentName',
    'guestName',
    'tourName',
    'vehicleNumber'
  ]);

  useEffect(() => {
    const { agentName, guestName, tourName, vehicleNumber } = filterGetValues();
    if (agentName || guestName || tourName || vehicleNumber) {
      setErrorMessage('');
    }
  }, [watchedFields, filterGetValues]);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    breadcrumbs.setViews(false);
    const payloads = {
      autoplannerID: scheduleDate,
      tripMode: tripMode,
      PageNo: 1,
      PageSize: 20
    };
    clearFilter();
    if (isChecked) {
      dispatch(autoGeneratedTripsAction(payloads));
    } else {
      dispatch(switchTripsAction(payloads));
    }
    setExpanded(false);
  };

  const handleWhatsappShare = async () => {
    if (!whatsappEnabled) {
      const payload = {
        autoplannerId: scheduleDate,
        publish: 1
      };
      const action = await dispatch(sendwhatsappAction(payload));
      setPublishWhatsapp(false);
    }
  };

  const handleImportfiles = async () => {
    if (importFile !== null) {
      const invalidRows = excelRows.map((items: any) => items.sno);
      setErrorShow(false);
      const action = await dispatch(
        autoPlannerImportTripsAction({ file: importFile, invalidRows, isReUpload: 1 })
      );
      if (action.type === autoPlannerImportTripsAction.rejected.type) {
        dispatch(
          updateData({ progress: 'FAILED', date: 'Loading', action: 'ExcelUpload' })
        );
        if (connection) connection.close();
      } else {
        dispatch(updateData({ progress: 0, date: 'Loading', action: 'ExcelUpload' }));
        setAlertClose(true);
      }
      setImportFilePickup(importFile);
      if (!isLoading) {
        handleCloseImport();
        setImportButtonDisable(true);
      }
    } else setErrorShow(true);
    if (error) {
      setIsDialog('Error');
    }
    if (connection !== null) connection.close();
    dispatch(createConnection(''));
    setTriggerCount(0);
  };

  const handleDialogGridClose = () => {
    setViewDialogGrid(false);
  };
  const handleViewOpen = () => {
    setViewDialogGrid(false);
    setImportButtonDisable(false);
  };

  const handleImportFile = () => {
    setIsDialog('Import');
    setOpenConnectionError(false);
    dispatch(clearAsyncSuccess());
    setCallAsync(false);
  };

  const handleCloseImport = () => {
    if (!isLoading) {
      setIsDialog('');
      setImportFile(null);
      // setExcelRows([]);
      // setErrorShow(false);
    }
  };

  const handleRemoveUploadedFile = () => {
    setImportFile(null);
    setExcelRows([]);
    setImportButtonDisable(true);
    setErrorShow(false);
  };

  useEffect(() => {
    if (profileData?.timezone && zone) {
      setTimeZone(profileData?.timezone);
      if (profileData?.timezone) setZone(false);
    }
  }, [profileData, zone]);

  useEffect(() => {
    navigate(location.pathname, { replace: true, state: location.state || {} });
  }, [location.pathname]);

  useEffect(() => {
    if (sortModel.length > 0) {
      const payload = {
        ...scheduledPayload,
        pageNo: 1,
        pageSize: pageSize,
        sortByField: sortModel[0].field,
        sortBy: sortModel[0].sort
      };
      setPageNo(1);
      setScheduledPayload(payload);
    }
  }, [sortModel]);

  useEffect(() => {
    if (scheduleDate !== 0 && !apiCalled && generateClicked) {
      const payloads = {
        autoplannerID: scheduleDate,
        tripMode: tripMode,
        PageNo: 1,
        PageSize: 20
      };
      dispatch(filterVehicleAction(payloads));
      if (switchType === 'All') {
        dispatch(getExcelAction(payloads));
      } else {
        dispatch(switchTripsAction(payloads));
      }
      setGenerateClicked(false);
    }
  }, [generateClicked, switchType, apiCalled]);

  useEffect(() => {
    if (switchType !== 'All') {
      setApiCalled(false);
    }
  }, [switchType]);

  useEffect(() => {
    dispatch(clearScheduleData());
  }, [tripMode]);

  useEffect(() => {
    if (timeZone !== 'UTC') {
      const epochTime = getTomorrowEpoch(timeZone);
      GetTomorrowDate(epochTime);
      setScheduleDate(date ? date : epochTime);
      if (epochTime) setValue('reportDate', formatDateFromEpoch(epochTime));
    }
  }, [timeZone, date]);

  useEffect(() => {
    if (abortController.current) abortController.current.abort();
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    // dispatch(getMyProfileAction(signal));
    createAbort();
    const { abortCall } = createAbort();
    const signals = abortCall?.signal;
    const data = { signals, mode: tripMode };
    dispatch(autoPlannerRoutesAction(data));
    return () => {
      if (abortController.current) abortController.current.abort();
    };
  }, [tripMode]);

  useEffect(() => {
    if (scheduleDate) {
      const payload = {
        date: scheduleDate,
        mode: tripMode
      };
      dispatch(tourAgentDropdown(payload));
    }
  }, [tripMode, scheduleDate]);

  const handleSendNotification = async () => {
    const payload = {
      date: scheduleDate
    };

    setStatus('sending');
    const action = await dispatch(sendAgentNotification(payload));
    if (action.type === sendAgentNotification.fulfilled.type) {
      setStatus('sent');
    }
  };

  useEffect(() => {
    if (status === 'sent') {
      setTimeout(() => {
        setStatus('idle');
      }, 2000);
    }
  }, [status]);

  useEffect(() => {
    if (excelDatas?.length > 1) {
      const allowedHeaders = new Set([
        'date',
        'time',
        'agent',
        'tour',
        'ref no',
        'guest',
        'guest contact number',
        'adult',
        'child',
        'from',
        'to',
        'driver',
        'vehicle number',
        's.no'
      ]);
      const headers = excelDatas[0].map((header: string) => header.toLowerCase().trim());

      const invalidHeaderRegex = /[^a-z.\s]/i;

      const invalidHeaders = headers.filter(
        (header: any) => !allowedHeaders.has(header) || invalidHeaderRegex.test(header)
      );

      if (invalidHeaders.length > 0) {
        dispatch(
          updateToast({
            show: true,
            message: `Invalid header names found: ${invalidHeaders.join(', ')}`,
            severity: 'warning'
          })
        );
        return;
      }

      const excelJSON = excelDatas
        .slice(1)
        .filter((row: any) =>
          row.some((value: any) => value !== undefined && value !== '')
        )
        .map((row: any, index: number) => {
          const rowObject = headers.reduce(
            (acc: any, header: string, colIndex: number) => {
              acc[header] = row[colIndex];
              return acc;
            },
            {}
          );

          return {
            id: index + 1,
            sno: index + 2,
            date: rowObject['date'],
            time: rowObject['time'],
            agent: rowObject['agent'],
            tour: rowObject['tour'],
            refNo: rowObject['refno'],
            guest: isNaN(rowObject['guest'])
              ? rowObject['guest']
              : Number(rowObject['guest']),
            guestcontactnumber: rowObject['guest contact number']
              ? rowObject['guest contact number']
              : null,
            adult: /^\d+$/.test(rowObject['adult'])
              ? Number(rowObject['adult'])
              : rowObject['adult'],
            child: /^\d+$/.test(rowObject['child'])
              ? Number(rowObject['child'])
              : rowObject['child'],
            source: isNaN(rowObject['from'])
              ? rowObject['from']
              : Number(rowObject['from']),
            destination: isNaN(rowObject['to'])
              ? rowObject['to']
              : Number(rowObject['to'])
          };
        });

      setJsonData(excelJSON);

      let filteredData = excelJSON.filter(
        ({
          sno,
          date,
          time,
          refNo,
          guest,
          source,
          destination,
          tour,
          agent,
          child,
          guestcontactnumber,
          adult
        }: any) => {
          // let tomorrowDate = getTomorrowEpoch(timeZone);
          // let sheetDate = dayjs
          //   .unix(Date.parse(date) / 1000)
          //   .tz(timeZone)
          //   .startOf('day')
          //   .unix();
          if (
            [
              typeof sno,
              typeof date,
              typeof time,
              typeof refNo,
              typeof tour,
              typeof guest,
              typeof source,
              typeof destination,
              typeof refNo,
              typeof guestcontactnumber,
              typeof agent
            ].every(item => item !== 'string')
          ) {
            return true;
          } else if (!['PVT', 'SIC', 'GRP', 'TSIC', 'RLR'].includes(tour.trim())) {
            return true;
          } else if (child && typeof child !== 'number') {
            return true;
          } else if (
            [sno, date, time, guest, source, destination, tour, agent, adult].includes(
              undefined
            )
          ) {
            return true;
          } else if (typeof adult !== 'number') {
            return true;
            // } else if (
            //   !/^(0?[1-9]|[12][0-9]|3[01]) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) \d{2}$|^(0?[1-9]|[12][0-9]|3[01])-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-\d{2}$/.test(
            //     date
            //   )
            // ) {
            //   return true;
            // } else if (!/((1[0-2]|0?[1-9])(:([0-5][0-9])) ?([AaPp][Mm])$)/.test(time)) {
            //   return true;
            // } else if (!(sheetDate == tomorrowDate)) {
            //   return true;
            // } else if ([agent, guest, source, destination].some(item => !isNaN(item))) {
            //   return true;
            // } else if (
            //   !(
            //     [
            //       ...(new Map(
            //         excelJSON.map((item: any) => [item['date'], item])
            //       ).values() as any)
            //     ].length <= 1
            //   )
            // ) {
            //   return true;
            // } else return false;
          }
        }
      );

      setExcelRows(filteredData);
      setINExcelRows(filteredData);
      filteredData?.length === 0 && setImportButtonDisable(false);
      setViewDialogGrid(true);
    }
  }, [excelDatas]);

  useEffect(() => {
    let interval: any;
    if (callAsync) {
      interval = setInterval(async () => {
        if (
          !asynSuccessLoading &&
          asyncSuccessData?.progress !== '100' &&
          !asyncSuccessError
        ) {
          await dispatch(asyncSuccessAction('CommenceJobSheetProcessingEvent'));
        } else if (callAsync && asyncSuccessError) {
          setOpenConnectionError(true);
          setAlertClose(false);
        }
      }, 2000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [callAsync, asyncSuccessError, asynSuccessLoading, asynSuccessLoading]);

  useEffect(() => {
    if (connection) {
      connection.onopen = () => {};
      connection.onmessage = (e: any) => {
        dispatch(updateData(JSON.parse(e?.data)));
        const value = JSON.parse(e?.data)?.progress;
        if (value === 'SAVED' && JSON.parse(e?.data)?.action === 'ExcelUpload') {
          setAlertClose(false);
          const signal = createAbort().abortCall.signal;
          const payload = {
            PageNo: 1,
            PageSize: pageSize,
            autoplannerID: scheduleDate,
            tripMode: 'ALL',
            signal: signal
          };
          dispatch(getExcelAction(payload));
          setImportFile(null);
        }
      };

      connection.onclose = () => {};
    }
  }, [connection]);

  let excelColumns = [
    {
      field: 'sno',
      headerName: 'Row No',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'date',
      headerName: 'Date',
      minWidth: 150,
      flex: 1,
      description:
        [...(new Map(jsonDATA.map((item: any) => [item['date'], item])).values() as any)]
          .length > 1
          ? 'Date must be common for all trips'
          : '',
      renderCell: (params: any) => {
        let tomorrowDate = getTomorrowEpoch(timeZone);
        let sheetDate = dayjs
          .unix(Date.parse(params.value) / 1000)
          .tz(timeZone)
          .startOf('day')
          .unix();
        const misMatch = tomorrowDate != sheetDate;
        return (
          <Tooltip title={misMatch ? `It's not tomorrow's date` : ''} arrow>
            <Box>{params.value}</Box>
          </Tooltip>
        );
      },
      headerClassName: (params: any) => {
        let newArr = [
          ...(new Map(jsonDATA.map((item: any) => [item['date'], item])).values() as any)
        ];
        if (!(newArr.length <= 1)) {
          return 'super-app-theme--header';
        }
      },
      cellClassName: (params: any) => {
        let tomorrowDate = getTomorrowEpoch(timeZone);
        let sheetDate = dayjs
          .unix(Date.parse(params.value) / 1000)
          .tz(timeZone)
          .startOf('day')
          .unix();
        let regex =
          /^(0?[1-9]|[12][0-9]|3[01]) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) \d{2}$|^(0?[1-9]|[12][0-9]|3[01])-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-\d{2}$/;
        let newArr = [
          ...(new Map(jsonDATA.map((item: any) => [item['date'], item])).values() as any)
        ];
        if (!regex.test(params.value)) {
          return 'super-app-theme--cell';
        } else if (!(sheetDate == tomorrowDate)) {
          return 'super-app-theme--cell';
        }
      }
    },
    {
      field: 'time',
      headerName: 'Time',
      minWidth: 150,
      flex: 1,
      cellClassName: (params: any) => {
        let regex = /((1[0-2]|0?[1-9])(:([0-5][0-9])) ?([AaPp][Mm])$)/;
        if (!regex.test(params.value)) return 'super-app-theme--cell';
      }
    },
    {
      field: 'agent',
      headerName: 'Agent',
      minWidth: 150,
      flex: 1,
      cellClassName: (params: any) => {
        if (!params.value || !isNaN(params.value)) return 'super-app-theme--cell';
      }
    },
    {
      field: 'tour',
      headerName: 'Tour',
      minWidth: 150,
      flex: 1,
      cellClassName: (params: any) => {
        if (!['PVT', 'SIC', 'TSIC', 'GRP', 'RLR'].includes(params.value) || !params.value)
          return 'super-app-theme--cell';
      }
    },
    {
      field: 'refNo',
      headerName: 'Ref No .',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'guest',
      headerName: 'Guest',
      minWidth: 150,
      flex: 1,
      cellClassName: (params: any) => {
        if (!params.value) {
          return 'super-app-theme--cell';
        } else if (typeof params.value !== 'string') {
          return 'super-app-theme--cell';
        }
      }
    },
    {
      field: 'guestcontactnumber',
      headerName: 'Guest Contact Number',
      minWidth: 200,
      flex: 1,
      cellClassName: (params: any) => {
        let regex = /^\+\d{1,3}\s\d{8,12}$/;
        if (params.value && !regex.test(params.value)) {
          return 'super-app-theme--cell';
        }
      }
    },
    {
      field: 'adult',
      headerName: 'Adult',
      minWidth: 150,
      flex: 1,
      cellClassName: (params: any) => {
        if (typeof params.value !== 'number' || !params.value)
          return 'super-app-theme--cell';
      }
    },
    {
      field: 'child',
      headerName: 'Child',
      minWidth: 150,
      flex: 1,
      cellClassName: (params: any) => {
        if (params.value && typeof params.value !== 'number')
          return 'super-app-theme--cell';
      }
    },
    {
      field: 'source',
      headerName: 'Source',
      minWidth: 150,
      flex: 1,
      cellClassName: (params: any) => {
        if (!params.value || typeof params.value !== 'string')
          return 'super-app-theme--cell';
      }
    },
    {
      field: 'destination',
      headerName: 'Destination',
      minWidth: 150,
      flex: 1,
      cellClassName: (params: any) => {
        if (!params.value || typeof params.value !== 'string')
          return 'super-app-theme--cell';
      }
    }
  ];

  const ring = keyframes`
  0% { transform: rotate(0deg); }
  10% { transform: rotate(10deg); }
  20% { transform: rotate(-10deg); }
  30% { transform: rotate(8deg); }
  40% { transform: rotate(-8deg); }
  50% { transform: rotate(5deg); }
  60% { transform: rotate(-5deg); }
  70% { transform: rotate(3deg); }
  80% { transform: rotate(-3deg); }
  90% { transform: rotate(1deg); }
  100% { transform: rotate(0); }
`;

  // Checkmark appearing animation
  const check = keyframes`
  0% { transform: scale(0); opacity: 0; }
  50% { transform: scale(1.2); opacity: 0.5; }
  100% { transform: scale(1); opacity: 1; }
`;
  useEffect(() => {
    clearFilter();
  }, [scheduleDate]);

  return (
    <Box className='auto-planner-scheduled-component'>
      <Box
        className={`auto-planner-calendar ${
          APoperator || APsuperAdmin
            ? 'auto-planner-calendar-opertor auto-mixin'
            : 'auto-planner-calendar-agent'
        } ${expanded && 'filter'}`}
      >
        {!APoperator && !APsuperAdmin ? (
          <Typography sx={{ fontSize: '22px', fontWeight: 600, marginRight: '20px' }}>
            Scheduled
          </Typography>
        ) : (
          ''
        )}
        {/* <CustomDateCalendar
          id='report-date'
          name='reportDate'
          control={control}
          type='user-profile'
          isOptional={true}
          className='calendar'
          placeholder='Choose Date'
          value={
            timeZone !== 'UTC'
              ? dayjs.unix(scheduleDate).tz(timeZone)
              : dayjs.unix(scheduleDate)
          }
          onDateChange={(date: any) => {
            if (date?.$d != 'Invalid Date') {
              setValue('reportDate', formatDateSg(date?.$d, timeZone));
              setScheduleDate(convertDatetoEpochSg(date?.$d, timeZone));
              onGenerate(convertDatetoEpochSg(date?.$d, timeZone));
            }
            clearErrors('reportDate');
            // onGenerate(convertDatetoEpochSg(date?.$d, timeZone));
          }}
        /> */}
        {APoperator || APsuperAdmin ? (
          <Box sx={{ marginLeft: '20px', cursor: 'pointer' }}>
            <CustomSwitch option1='All' option2='Tour Mode' onChange={onSwitchChange} />
          </Box>
        ) : (
          ''
        )}
      </Box>

      {switchType === 'Tour Mode' ? (
        <Box className='Auto-planner-container'>
          <Grid container>
            <Grid item sx={{ width: expanded ? 'calc(100% - 300px)' : '100%' }}>
              <Box className='schedule-trip'>
                <DateLabel />
                {((reportData as any)?.data?.standardTourBookingInfo?.length > 0 ||
                  (reportData as any)?.data?.customTourOverview?.length > 0 ||
                  data?.length > 0) && (
                  <Box sx={{ display: 'flex' }}>
                    <Box className='buttons'>
                      {/* <Typography className='text'>Share To</Typography> */}
                      {APoperator || APsuperAdmin ? (
                        <>
                          {(tabValue === 0 || tabValue === 1) && (
                            <Tooltip title={tripisXs ? 'Group View' : ''}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginTop: '5px',
                                  marginRight: '10px'
                                }}
                              >
                                <Switch
                                  checked={checked}
                                  onChange={handleSwitchChange}
                                  inputProps={{ 'aria-label': 'controlled' }}
                                />
                                <Typography>Group view</Typography>
                              </Box>
                            </Tooltip>
                          )}
                          {tripisXs ? (
                            <>
                              <Tooltip title={'Agent'}>
                                <Icon
                                  icon='mdi:face-agent'
                                  width='35'
                                  height='35'
                                  onClick={() => setIsDialog('share')}
                                  style={{
                                    backgroundColor: '3239ea',
                                    marginRight: '10px',
                                    padding: '5px',
                                    color: 'white',
                                    borderRadius: '5px 5px 5px 5px',
                                    marginTop: '7px',
                                    cursor: 'pointer'
                                  }}
                                />
                              </Tooltip>
                              <Tooltip
                                title={APagent || APsubAgents ? 'Get Report' : 'Operator'}
                              >
                                <Icon
                                  icon='carbon:kubernetes-operator'
                                  width='35'
                                  height='35'
                                  onClick={handleDownloadTrip}
                                  style={{
                                    backgroundColor: '3239ea',
                                    marginRight: '10px',
                                    padding: '5px',
                                    color: 'white',
                                    borderRadius: '5px 5px 5px 5px',
                                    marginTop: '4px',
                                    cursor: 'pointer'
                                  }}
                                />
                              </Tooltip>
                            </>
                          ) : (
                            <>
                              <CustomButton
                                className='saveChanges share-btn'
                                category='Agent'
                                icon='mynaui:send-solid'
                                onClick={() => setIsDialog('share')}
                              />
                              {/* <CustomButton
                                className='mail-button'
                                category='Operator'
                                icon='mynaui:send-solid'
                                onClick={handleDownloadTrip}
                              /> */}
                              {(APoperator || APsuperAdmin) &&
                              scheduleDate === getTomorrowEpoch(timeZone) ? (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    gap: '2px',
                                    alignItems: 'Right',
                                    paddingRight: '10px'
                                  }}
                                >
                                  {error?.invalidExcelRows?.length > 0 ? (
                                    <Tooltip
                                      title='View Invalid Data'
                                      TransitionProps={{ timeout: 300 }}
                                      TransitionComponent={Zoom}
                                      placement='top'
                                      arrow
                                    >
                                      <Box
                                        onClick={() => {
                                          setIsDialog('Error');
                                        }}
                                        sx={{ cursor: 'pointer' }}
                                      >
                                        <Icon
                                          icon='mingcute:question-fill'
                                          className='invalid-data-icon'
                                        />
                                      </Box>
                                    </Tooltip>
                                  ) : null}
                                  {uploading ? (
                                    <Tooltip
                                      title={
                                        'Once the sheet has been uploaded, you can import it'
                                      }
                                      TransitionProps={{ timeout: 300 }}
                                      TransitionComponent={Zoom}
                                      placement='top'
                                      arrow
                                    >
                                      <Icon
                                        icon='ep:warning-filled'
                                        className='invalid-data-icon'
                                        style={{ color: 'orange' }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    ''
                                  )}
                                  {isXs ? (
                                    <Tooltip title={'Import'}>
                                      <Icon
                                        icon='solar:import-outline'
                                        width='30'
                                        height='30'
                                        onClick={handleImportFile}
                                        style={{
                                          backgroundColor: '3239ea',
                                          marginRight: '10px',
                                          padding: '5px',
                                          color: 'white',
                                          borderRadius: '5px 5px 5px 5px',
                                          cursor: 'pointer',
                                          marginBottom: '4px'
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CustomButton
                                      className='cancel import-button'
                                      category='Import'
                                      disabled={uploading}
                                      startIcon={<Icon icon='mage:file-upload' />}
                                      sx={{
                                        paddingLeft: '10px !important',
                                        paddingRight: '10px !important'
                                      }}
                                      onClick={handleImportFile}
                                    />
                                  )}
                                </Box>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        ''
                      )}
                      <Box
                        className={`download-button ${
                          downloadLoader && 'download-button-disable'
                        }`}
                        onClick={() => {
                          !downloadLoader && handleSheetDownload();
                        }}
                      >
                        {!downloadLoader ? (
                          <>
                            <Typography className='download-button-text'>
                              Download
                            </Typography>
                            <Box className='download-button-icon'>
                              <Icon icon='tabler:download' className='download-icon2' />
                            </Box>
                          </>
                        ) : (
                          <Box className='loader-icon-button2'>
                            <Icon icon='codex:loader' className='loader-icon2' />
                          </Box>
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ marginTop: '5px', marginLeft: '10px' }}>
                      {!expanded && !breadcrumbs.views && (
                        <Tooltip
                          title='Filter'
                          placement='right'
                          arrow
                          TransitionProps={{ timeout: 200 }}
                          TransitionComponent={Zoom}
                        >
                          <IconButton onClick={handleToggle} className='filter-icon'>
                            <Badge badgeContent={filteerCount} color='primary'>
                              <Icon icon='mage:filter' />
                            </Badge>
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
              <Box className='d-flex auto-planner-header'>
                <Box>
                  <CustomTab onChange={handleTrip} value={tabValue} tabList={tripList} />
                </Box>
              </Box>
              {tripMode === 'SIC' && (
                <ScheduledSic
                  setPayload={setPayloadState}
                  tripPayloads={tripPayload}
                  scheduleDate={scheduleDate}
                  checked={checked}
                  setBreadCrumbs={setBreadCrumbs}
                  initialLoad={initialLoad}
                  setVehicles={setVehicles}
                  agent={agent}
                  guest={guest}
                  tour={tour}
                  vehicle={vehicle}
                />
              )}
              {tripMode === 'TSIC' && (
                <ScheduledTsic
                  setPayload={setPayloadState}
                  tripPayloads={tripPayload}
                  scheduleDate={scheduleDate}
                  checked={checked}
                  setBreadCrumbs={setBreadCrumbs}
                  initialLoad={initialLoad}
                  setVehicles={setVehicles}
                  agent={agent}
                  guest={guest}
                  tour={tour}
                  vehicle={vehicle}
                />
              )}
              {tripMode === 'PVT' && (
                <ScheduledPvt
                  setPayload={setPayloadState}
                  scheduleDate={scheduleDate}
                  vehicle={vehicle}
                  agent={agent}
                />
              )}
              {tripMode === 'GRP' && (
                <ScheduledGrp
                  setPayload={setPayloadState}
                  scheduleDate={scheduleDate}
                  vehicle={vehicle}
                  agent={agent}
                />
              )}
              {tripMode === 'RLR' && <ScheduledRLR scheduleDate={scheduleDate} />}
            </Grid>
            <Grid item sx={{ width: expanded ? '300px' : '0' }}>
              {expanded && (
                <Box
                  className={`filter-drawer ${expanded ? 'filter-show' : 'filter-hide'}`}
                >
                  <Box className='filter-header'>
                    <IconButton onClick={handleToggle} className='filter-icon-arrow '>
                      <Icon
                        icon='weui:arrow-filled'
                        style={{ width: '35px', height: '35px' }}
                      />
                    </IconButton>
                    <Typography paragraph className='filter-title'>
                      Filter
                    </Typography>
                  </Box>
                  <Box
                    className={`filter-bar ${expanded ? 'show' : ''}`}
                    component='form'
                    onSubmit={handleSubmit(onFilterSubmit)}
                  >
                    <Box className='filter-fields'>
                      <CustomSelect
                        id='vehicleNumber'
                        control={filterControl}
                        name='vehicleNumber'
                        label='Vehicle Number'
                        placeholder='Select Vehicle Number'
                        options={vehicleNumber}
                        isOptional={true}
                        onChanges={(e: any, newValue: any) => setVehicle(newValue?.id)}
                      />
                    </Box>
                    {(APsuperAdmin || APoperator) && (
                      <Box className='filter-fields'>
                        <CustomSelect
                          id='agentName'
                          control={filterControl}
                          name='agentName'
                          label='Agent'
                          placeholder='Select Agent'
                          options={agentNames}
                          onChanges={(e: any, newValue: any) => setAgent(newValue?.id)}
                          isOptional={true}
                        />
                      </Box>
                    )}
                    {tripMode === 'SIC' || tripMode === 'TSIC' ? (
                      <Box className='filter-fields'>
                        <CustomSelect
                          id='tourName'
                          control={filterControl}
                          name='tourName'
                          label='Tour Name'
                          placeholder='Select Tour Name'
                          options={configuredRoute}
                          isOptional={true}
                          onChanges={(e: any, newValue: any) => setTour(newValue?.id)}
                        />
                      </Box>
                    ) : (
                      ''
                    )}
                    <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                      <Grid item xs={6}>
                        <CustomButton
                          category={'Clear Filter'}
                          sx={{ width: '100%', padding: '7.5px !important' }}
                          className='cancel'
                          onClick={filterClear}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CustomButton
                          category={'Filter'}
                          loading={filteerCount > 0 ? SICLoad : false}
                          className='saveChanges'
                          sx={{ width: '100%' }}
                          type='submit'
                        />
                      </Grid>
                    </Grid>
                  </Box>

                  {errorMessage && (
                    <Typography
                      sx={{ color: '#d32f2f', marginTop: 2, fontSize: '0.9rem' }}
                    >
                      {errorMessage}
                    </Typography>
                  )}
                </Box>
              )}
            </Grid>
          </Grid>

          {isUpdate && (
            <UpdateScheduleTrip
              isUpdate={isUpdate}
              setIsUpdate={setIsUpdate}
              selectedRow={selectedRow}
              autoplannerID={scheduleDate}
              tripMode={tripMode}
            />
          )}
        </Box>
      ) : (
        <Box className='Auto-planner-container'>
          <Grid container>
            <Grid item sx={{ width: '100%' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: APagent || APsubAgents ? '-8px' : '0px'
                }}
                className='schedule-all'
              >
                <DateLabel />
                {excelData?.length > 0 && (
                  <Box className='buttons'>
                    {/* <Box
                      sx={{
                        mx: 'auto',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        justifyContent: 'center'
                      }}
                    >
                      <Box
                        onClick={handleSendNotification}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          py: { xs: 0.75, sm: 1 },
                          px: { xs: 2, sm: 3 },
                          fontSize: { xs: '0.75rem', sm: '0.875rem' },
                          fontWeight: 500,
                          borderRadius: 2,
                          color: 'white',
                          cursor: status !== 'sending' ? 'pointer' : 'not-allowed',
                          backgroundColor:
                            status === 'sent'
                              ? 'green'
                              : status === 'sending'
                              ? '#B2BEB5'
                              : '#1976d2',
                          '&:hover': {
                            backgroundColor: status === 'idle' ? '#1565c0' : undefined
                          },
                          transition: 'background-color 0.3s ease',
                          margin: '3px 10px 0 0',
                          minWidth: '160px',
                          width: 'fit-content'
                        }}
                      >
                        {status === 'sending' ? (
                          <Loader
                            className='animate-spin'
                            size={16}
                            style={{
                              animation: 'spin 1s linear infinite'
                            }}
                          />
                        ) : status === 'sent' ? (
                          <CheckCircle
                            className='mr-2'
                            size={20}
                            style={checkmarkAnimationStyle}
                          />
                        ) : (
                          <Bell
                            size={16}
                            className='mr-2'
                            style={status === 'idle' ? bellRingStyle : undefined}
                          />
                        )}
                        <Box component='span' sx={{ ml: 1 }}>
                          {status === 'sending'
                            ? 'Sending...'
                            : status === 'sent'
                            ? 'Sent!'
                            : 'Notify Agents'}
                        </Box>
                      </Box>
                    </Box> */}
                    {(APsuperAdmin || APoperator) && (
                      <Box sx={{ display: 'flex', paddingRight: '10px' }}>
                        {isMobile ? (
                          <IconButton
                            sx={{
                              backgroundColor: '#FF6B35',
                              color: 'white',
                              '&:hover': { backgroundColor: '#E55A2B' }
                            }}
                            onClick={() => setIsDialog('publish')}
                          >
                            <RocketLaunchIcon />
                          </IconButton>
                        ) : (
                          <Button
                            variant='contained'
                            className='publish'
                            startIcon={<RocketLaunchIcon />}
                            sx={{
                              backgroundColor: '#FF6B35',
                              color: 'white',
                              textTransform: 'capitalize',
                              '&:hover': { backgroundColor: '#E55A2B' }
                            }}
                            onClick={() => setIsDialog('publish')}
                          >
                            Publish & Send
                          </Button>
                        )}
                      </Box>
                    )}
                    {!APsuperAdmin && !APoperator ? (
                      <>
                        {isShare ? (
                          <Tooltip title={'Share Trip'}>
                            <Icon
                              icon='ic:sharp-whatsapp'
                              width='35'
                              height='35'
                              onClick={() => setIsDialog('whatsapp')}
                              style={{
                                backgroundColor: '#25D366',
                                marginRight: '10px',
                                padding: '5px',
                                color: 'white',
                                borderRadius: '5px 5px 5px 5px',
                                marginTop: '7px',
                                cursor: 'pointer'
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <Button
                            variant='contained'
                            className='whatsapp'
                            startIcon={<WhatsAppIcon />}
                            sx={{
                              backgroundColor: '#25D366',
                              color: 'white',
                              '&:hover': { backgroundColor: '#1EBE57' }
                            }}
                            onClick={() => setIsDialog('whatsapp')}
                          >
                            Share Trip
                          </Button>
                        )}
                      </>
                    ) : (
                      ''
                    )}
                    {!APagent && !APsubAgents ? (
                      <Box>
                        {isMd ? (
                          <Tooltip title={'Agent'}>
                            <Icon
                              icon='mdi:face-agent'
                              width='35'
                              height='35'
                              onClick={() => setIsDialog('share')}
                              style={{
                                backgroundColor: '3239ea',
                                marginRight: '10px',
                                padding: '5px',
                                color: 'white',
                                borderRadius: '5px 5px 5px 5px',
                                marginTop: '7px',
                                cursor: 'pointer'
                              }}
                            />
                          </Tooltip>
                        ) : (
                          // <CustomButton
                          //   className='saveChanges share-btn'
                          //   sx={{ marginRight: '10px' }}
                          //   category='Agent'
                          //   icon='mynaui:send-solid'
                          //   onClick={() => setIsDialog('share')}
                          // />
                          <></>
                        )}
                      </Box>
                    ) : (
                      ''
                    )}
                    {isMd ? (
                      <Tooltip title={APagent || APsubAgents ? 'Get Report' : 'Operator'}>
                        <Icon
                          icon='carbon:kubernetes-operator'
                          width='35'
                          height='35'
                          onClick={handleDownloadTrip}
                          style={{
                            backgroundColor: '3239ea',
                            marginRight: '10px',
                            padding: '5px',
                            color: 'white',
                            borderRadius: '5px 5px 5px 5px',
                            marginTop: '4px',
                            cursor: 'pointer'
                          }}
                        />
                      </Tooltip>
                    ) : (
                      // <CustomButton
                      //   className='mail-button'
                      //   category={APagent || APsubAgents ? 'Get Report' : 'Operator'}
                      //   icon='mynaui:send-solid'
                      //   onClick={handleDownloadTrip}
                      // />
                      <>
                        {(APoperator || APsuperAdmin) &&
                        scheduleDate === getTomorrowEpoch(timeZone) ? (
                          <Box
                            sx={{
                              display: 'flex',
                              gap: '2px',
                              alignItems: 'Right'
                            }}
                          >
                            {error?.invalidExcelRows?.length > 0 ? (
                              <Tooltip
                                title='View Invalid Data'
                                TransitionProps={{ timeout: 300 }}
                                TransitionComponent={Zoom}
                                placement='top'
                                arrow
                              >
                                <Box
                                  onClick={() => {
                                    setIsDialog('Error');
                                  }}
                                  sx={{ cursor: 'pointer' }}
                                >
                                  <Icon
                                    icon='mingcute:question-fill'
                                    className='invalid-data-icon'
                                  />
                                </Box>
                              </Tooltip>
                            ) : null}
                            {uploading ? (
                              <Tooltip
                                title={
                                  'Once the sheet has been uploaded, you can import it'
                                }
                                TransitionProps={{ timeout: 300 }}
                                TransitionComponent={Zoom}
                                placement='top'
                                arrow
                              >
                                <Icon
                                  icon='ep:warning-filled'
                                  className='invalid-data-icon'
                                  style={{ color: 'orange' }}
                                />
                              </Tooltip>
                            ) : (
                              ''
                            )}
                            {isXs ? (
                              <Tooltip title={'Import'}>
                                <Icon
                                  icon='solar:import-outline'
                                  width='30'
                                  height='30'
                                  onClick={handleImportFile}
                                  style={{
                                    backgroundColor: '3239ea',
                                    marginRight: '10px',
                                    padding: '5px',
                                    color: 'white',
                                    borderRadius: '5px 5px 5px 5px',
                                    cursor: 'pointer',
                                    marginBottom: '4px'
                                  }}
                                />
                              </Tooltip>
                            ) : (
                              <CustomButton
                                className='cancel import-button'
                                category='Import'
                                disabled={uploading}
                                startIcon={<Icon icon='mage:file-upload' />}
                                sx={{
                                  paddingLeft: '10px !important',
                                  paddingRight: '10px !important'
                                }}
                                onClick={handleImportFile}
                              />
                            )}
                          </Box>
                        ) : (
                          ''
                        )}
                      </>
                    )}
                    <Box
                      className={`download-button ${
                        downloadLoader && 'download-button-disable'
                      }`}
                      onClick={() => {
                        !downloadLoader && handleSheetDownload();
                      }}
                    >
                      {!downloadLoader ? (
                        <>
                          <Typography className='download-button-text'>
                            Download
                          </Typography>
                          <Box className='download-button-icon'>
                            <Icon icon='tabler:download' className='download-icon2' />
                          </Box>
                        </>
                      ) : (
                        <Box className='loader-icon-button2'>
                          <Icon icon='codex:loader' className='loader-icon2' />
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ marginTop: '5px', marginLeft: '10px' }}>
                      {!expanded && (
                        <Tooltip
                          title='Filter'
                          placement='right'
                          arrow
                          TransitionProps={{ timeout: 200 }}
                          TransitionComponent={Zoom}
                        >
                          <IconButton onClick={handleToggle} className='filter-icon'>
                            <Badge badgeContent={filteerCount} color='primary'>
                              <Icon icon='mage:filter' />
                            </Badge>
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
              {tripMode === 'ALL' && (
                <ExcelView
                  scheduleDate={scheduleDate}
                  initialLoad={initialLoad}
                  tripPayloads={tripPayload}
                  agent={agent}
                  guest={guest}
                  tour={tour}
                  vehicle={vehicle}
                  setPayload={setPayloadState}
                  setSearchPayload={setSearchPayload}
                />
              )}
            </Grid>
            <Grid item sx={{ width: expanded ? '300px' : '0', position: 'absolute' }}>
              {expanded && (
                <Box
                  className={`filter-drawer ${expanded ? 'filter-show' : 'filter-hide'}`}
                >
                  <Box className='filter-header'>
                    <IconButton onClick={handleToggle} className='filter-icon-arrow'>
                      <Icon
                        icon='weui:arrow-filled'
                        style={{ width: '35px', height: '35px' }}
                      />
                    </IconButton>
                    <Typography paragraph className='filter-title'>
                      Filter
                    </Typography>
                  </Box>
                  <Box
                    className={`filter-bar ${expanded ? 'show' : ''}`}
                    component='form'
                    onSubmit={handleSubmit(onFilterSubmit)}
                  >
                    <Box className='filter-fields'>
                      <CustomSelect
                        id='vehicleNumber'
                        control={filterControl}
                        name='vehicleNumber'
                        label='Vehicle Number'
                        placeholder='Select Vehicle Number'
                        options={vehicleNumber}
                        isOptional={true}
                        onChanges={(e: any, newValue: any) => setVehicle(newValue?.id)}
                      />
                    </Box>
                    {(APsuperAdmin || APoperator) && (
                      <Box className='filter-fields'>
                        <CustomSelect
                          id='agentName'
                          control={filterControl}
                          name='agentName'
                          label='Agent'
                          placeholder='Select Agent'
                          options={agentNames}
                          onChanges={(e: any, newValue: any) => setAgent(newValue?.id)}
                          isOptional={true}
                        />
                      </Box>
                    )}
                    <Box className='filter-fields'>
                      {/* <CustomTextField
                        id='guestName'
                        control={filterControl}
                        name='guestName'
                        label='Guest Name'
                        placeholder='Select Guest name'
                        isOptional={true}
                        onChangeCallback={(e: any) => setGuest(e)}
                      /> */}
                    </Box>
                    <Box className='filter-fields'>
                      <CustomSelect
                        id='tourName'
                        control={filterControl}
                        name='tourName'
                        label='Tour Name'
                        placeholder='Select Tour Name'
                        options={configuredRoute}
                        isOptional={true}
                        onChanges={(e: any, newValue: any) => setTour(newValue?.id)}
                      />
                    </Box>

                    <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                      <Grid item xs={6}>
                        <CustomButton
                          category={'Clear Filter'}
                          sx={{ width: '100%', padding: '7.5px !important' }}
                          className='cancel'
                          onClick={filterClear}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CustomButton
                          category={'Filter'}
                          className='saveChanges'
                          loading={filteerCount > 0 ? excelLoad : false}
                          sx={{ width: '100%' }}
                          type='submit'
                        />
                      </Grid>
                    </Grid>
                  </Box>

                  {errorMessage && (
                    <Typography
                      sx={{ color: '#d32f2f', marginTop: 2, fontSize: '0.9rem' }}
                    >
                      {errorMessage}
                    </Typography>
                  )}
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      )}
      <>
        {isDialog === 'publish' && (
          <Dialog
            open={isDialog === 'publish'}
            onClose={handleClose}
            maxWidth='xs'
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: 3,
                backgroundColor: '#f0f8ff',
                color: '#333333',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }
            }}
          >
            <DialogTitle
              sx={{
                textAlign: 'left',
                pb: 2,
                borderBottom: '1px solid #e5e5e5',
                display: 'flex',
                alignItems: 'center',
                gap: 2
              }}
            >
              <RocketLaunchIcon sx={{ fontSize: 24, color: '#1976d2' }} />
              <Typography variant='h6' component='span' fontWeight='600' color='#333333'>
                Publish Bookings
              </Typography>
            </DialogTitle>

            <DialogContent sx={{ px: 2.5, py: 2.5 }}>
              <Typography
                variant='body2'
                sx={{
                  mb: 3,
                  color: '#666666',
                  fontSize: '1.0rem',
                  fontWeight: 600,
                  lineHeight: 1.5
                }}
              >
                Scheduled bookings will be available to the respective agents upon
                publication.
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {/* WhatsApp Toggle */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 2.5,
                    backgroundColor: '#ffffff',
                    borderRadius: 3,
                    border: '1px solid #e3f2fd'
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={whatsappEnabled}
                        onChange={e => {
                          setWhatsappEnabled(e.target.checked);
                          if (e.target.checked) {
                            setPublishWhatsapp(true);
                          } else {
                            setPublishWhatsapp(false);
                          }
                          handleWhatsappShare();
                        }}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#1976d2'
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#1976d2'
                          }
                        }}
                      />
                    }
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <WhatsAppIcon sx={{ color: '#25D366', fontSize: 22 }} />
                        <Box>
                          <Typography variant='body1' fontWeight='500' color='#333333'>
                            WhatsApp Notifications
                          </Typography>
                          <Typography
                            variant='body2'
                            sx={{ color: '#666666', fontSize: '0.85rem' }}
                          >
                            Send trip details to all guests
                          </Typography>
                        </Box>
                      </Box>
                    }
                    sx={{ margin: 0, width: '100%' }}
                  />
                </Paper>

                {/* Email Toggle */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 2.5,
                    backgroundColor: '#ffffff',
                    borderRadius: 3,
                    border: '1px solid #e3f2fd'
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={emailEnabled}
                        onChange={e => setEmailEnabled(e.target.checked)}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#1976d2'
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#1976d2'
                          }
                        }}
                      />
                    }
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <EmailIcon sx={{ color: '#dc3545', fontSize: 22 }} />
                        <Box>
                          <Typography variant='body1' fontWeight='500' color='#333333'>
                            Email Confirmation
                          </Typography>
                          <Typography
                            variant='body2'
                            sx={{ color: '#666666', fontSize: '0.85rem' }}
                          >
                            {/* Send confirmation to assigned agent */}
                            Send confirmation email to the assigned agent
                          </Typography>
                        </Box>
                      </Box>
                    }
                    sx={{ margin: 0, width: '100%' }}
                  />
                </Paper>
              </Box>
            </DialogContent>

            <DialogActions sx={{ p: 2.5, pt: 2, gap: 2, borderTop: '1px solid #e3f2fd' }}>
              <Button
                onClick={handleClose}
                variant='outlined'
                startIcon={<CloseIcon />}
                disabled={publishLoading}
                sx={{
                  flex: 1,
                  py: 1.2,
                  px: 2.5,
                  borderColor: '#cbd5e1',
                  color: '#64748b',
                  borderRadius: 4,
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '0.95rem',
                  background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
                  boxShadow: '0 2px 8px rgba(100, 116, 139, 0.15)',
                  border: '2px solid #e2e8f0',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  '&:hover:not(:disabled)': {
                    borderColor: '#94a3b8',
                    color: '#475569',
                    background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)',
                    boxShadow: '0 4px 12px rgba(100, 116, 139, 0.2)',
                    transform: 'translateY(-1px)'
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handlePublish}
                variant='contained'
                startIcon={
                  publishLoading ? (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 20,
                        height: 20
                      }}
                    >
                      <RocketLaunchIcon
                        sx={{
                          fontSize: 20,
                          animation: 'rocketSpin 1s linear infinite'
                        }}
                      />
                    </Box>
                  ) : (
                    <RocketLaunchIcon />
                  )
                }
                disabled={publishLoading || publishWhatsapp}
                sx={{
                  flex: 1,
                  py: 1.2,
                  px: 2.5,
                  borderRadius: 4,
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '0.95rem',
                  background:
                    'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 50%, #1e40af 100%)',
                  boxShadow:
                    '0 4px 16px rgba(59, 130, 246, 0.4), 0 2px 8px rgba(59, 130, 246, 0.2)',
                  border: 'none',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  '&:hover:not(:disabled)': {
                    background:
                      'linear-gradient(135deg, #2563eb 0%, #1d4ed8 50%, #1e3a8a 100%)',
                    boxShadow:
                      '0 6px 20px rgba(59, 130, 246, 0.5), 0 4px 12px rgba(59, 130, 246, 0.3)',
                    transform: 'translateY(-2px)'
                  },
                  '&:disabled': {
                    background: 'linear-gradient(135deg, #94a3b8 0%, #64748b 100%)',
                    color: '#ffffff',
                    cursor: 'wait'
                  },
                  '@keyframes rocketSpin': {
                    '0%': { transform: 'rotate(0deg)' },
                    '100%': { transform: 'rotate(360deg)' }
                  }
                }}
              >
                {publishLoading ? 'Publishing...' : 'Publish Trip'}
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* {showSuccessAnimation && <SuccessAnimation />} */}
      </>
      <Dialog
        open={isDialog === 'Import'}
        className='import-dialog animate__animated animate__zoomIn'
        BackdropProps={{
          invisible: true
        }}
      >
        <Box className='import-file-dialog'>
          <Box className='d-flex import-file-head'>
            <Typography paragraph className='import-file-title'>
              Import Trip File
            </Typography>
            <Box className='import-file-close' onClick={handleCloseImport}>
              <Icon icon='ic:round-close' className='import-file-close-icon' />
            </Box>
          </Box>
          {importFile?.name ? (
            <Box className='uploaded-file'>
              <Box component={'img'} src={ExcelIcon} className='uploaded-excel-icon' />
              <Typography paragraph className='uploaded-excel-name'>
                {importFile.name}
              </Typography>
              <Box className='remove-uploaded-file' onClick={handleRemoveUploadedFile}>
                <Icon icon='ic:round-close' />
              </Box>
            </Box>
          ) : (
            <Box className='import-form'>
              <Box className='upload-btn' onClick={handleUpload}>
                Click to Upload file
              </Box>
              {errorShow && (
                <Typography className='file-error-message'>Select File</Typography>
              )}
            </Box>
          )}
          <Box className='disclaimer'>
            <Box className='disclaimer-head'>
              {/* <Icon icon='fluent-color:warning-24' style={{ fontSize: '22px' }} />
              <Typography paragraph className='disclaimer-title'>
                Only files in the specified format are allowed for upload
              </Typography>
              <Tooltip
                title='Click to download the sample sheet'
                TransitionProps={{ timeout: 300 }}
                TransitionComponent={Zoom}
                arrow
              >
                <Box
                  className='download-demo-file'
                  component='a'
                  // href={demofile}
                  download
                >
                  <Icon icon='tabler:download' className='file-download-icon' />
                </Box>
              </Tooltip> */}

              <Icon icon='fluent-color:warning-24' style={{ fontSize: '22px' }} />
              <Typography
                paragraph
                className='disclaimer-title'
                sx={{ fontSize: '12px !important' }}
              >
                Warning : Existing scheduled jobs will be erased.
              </Typography>
            </Box>
            <Box className='disclaimer-head'>
              <Icon icon='emojione-v1:empty-note-pad' style={{ fontSize: '22px' }} />
              <Typography
                paragraph
                className='disclaimer-title'
                sx={{ fontSize: '12px !important' }}
              >
                Note : Upload the sheet for tomorrow only.
              </Typography>
            </Box>
          </Box>

          <Box
            className='import-file-submit'
            sx={{
              justifyContent: excelRows?.length > 0 ? 'space-between' : 'flex-end'
            }}
          >
            {excelRows?.length > 0 && (
              <Tooltip
                onMouseOver={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                title='Invalid Excel Data'
                TransitionProps={{ timeout: 300 }}
                open={!viewDialogGrid && isHover}
                TransitionComponent={Zoom}
                arrow
              >
                <Box
                  onClick={() => {
                    setViewDialogGrid(true);
                    setIsHover(false);
                  }}
                >
                  <Icon icon='mingcute:question-fill' className='excel-data-icon' />
                </Box>
              </Tooltip>
            )}

            <Box sx={{ display: 'flex' }}>
              <Box sx={{ marginRight: '12px' }}>
                <CustomButton
                  className='cancel'
                  category='Cancel'
                  onClick={handleCloseImport}
                />
              </Box>
              <CustomButton
                className='saveChanges'
                category='Import'
                disabled={importButtonDisable}
                loading={load}
                onClick={handleImportfiles}
              />
            </Box>
          </Box>
        </Box>
      </Dialog>

      {viewDialogGrid && excelRows?.length > 0 && (
        <CustomDialogGrid
          rows={excelRows}
          type='autoplannertrip'
          columns={excelColumns}
          view={viewDialogGrid}
          handleViewClose={handleDialogGridClose}
          handleViewOpen={handleViewOpen}
        />
      )}

      {error?.invalidExcelRows?.length > 0 ? (
        <ErrorDialog isOpen={isDialog === 'Error'} onClose={handleClose} errors={error} />
      ) : (
        ''
      )}
      <Dialog open={isDialog === 'share' || isDialog === 'download'}>
        <Box
          sx={{
            textAlign: 'center',
            padding: '5%',
            minWidth: { xs: '100px', sm: '350px', md: '350px', lg: '350px' }
          }}
        >
          <Typography>
            {isDialog === 'download' ? constant.downloadReport : constant.ShareToAgent}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              paddingTop: '5%',
              justifyContent: 'center'
            }}
          >
            <Box sx={{ marginRight: '12px' }}>
              <CustomButton
                className='saveChanges'
                category='Yes'
                loading={isLoading}
                onClick={handleShareReport}
              />
            </Box>
            <CustomButton
              className='cancel'
              category='No'
              onClick={() => setIsDialog('')}
            />
          </Box>
        </Box>
      </Dialog>
      {openConnectionError && (
        <Dialog
          open={openConnectionError}
          className='feedback-dialog animate__animated animate__zoomIn animate__fast'
          BackdropProps={{
            invisible: true
          }}
        >
          <Box className='feedback-container' sx={{ minWidth: '350px' }}>
            <Box className='feedback-header'>
              <Typography paragraph className='feedback-title'>
                Alert
              </Typography>
            </Box>
            <Box className='alert-component'>
              <Typography className='alert-title'>
                Failed to upload the Excel file
              </Typography>
              <Typography className='alert-content'>Please upload again.</Typography>
              <Box className='alert-conform-btn'>
                <CustomButton
                  category={'Ok'}
                  className='saveChanges'
                  onClick={() => {
                    dispatch(clearAsyncSuccess());
                    setOpenConnectionError(false);
                    setCallAsync(false);
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Dialog>
      )}

      {isDialog === 'whatsapp' && (
        <Dialog open={isDialog === 'whatsapp'}>
          <Box
            sx={{
              textAlign: 'center',
              padding: '5%',
              minWidth: '350px'
            }}
          >
            <Typography>{constant.ShareToWhatsapp}</Typography>
            <Box
              sx={{
                paddingTop: '5%',
                display: 'flex',
                flexDirection: 'row',
                gap: '15px',
                justifyContent: 'center'
              }}
            >
              <CustomButton
                className='cancel'
                category='Cancel'
                variant='outlined'
                onClick={() => {
                  setIsDialog('');
                }}
              />
              <CustomButton
                className='saveChanges'
                category={'Send'}
                icon='mynaui:send-solid'
                loading={sendwhatsapp?.isLoading}
                onClick={handleSendWhatsapp}
              />
            </Box>
          </Box>
        </Dialog>
      )}

      {drawer && (
        <Dialog open={drawer} component={'form'} onSubmit={mailSubmit(sendMail)}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: '5%',
              width: { xs: '250px', sm: '500px', md: '500px', lg: '500px' }
            }}
          >
            <Typography sx={{ fontWeight: 700, paddingBottom: '3%' }}>
              Send Mail
            </Typography>
            <Box>
              <Box sx={{ marginBottom: '2%' }}>
                <CustomTextField
                  control={mailControl}
                  name={'email'}
                  id={'e-mail'}
                  label='Email ID'
                  placeholder='Email id'
                />
              </Box>

              {/* <Box>
                  <CustomSelect
                    id={'document'}
                    options={documentOption}
                    control={mailControl}
                    name='document'
                    label='Document Type'
                    placeholder='Enter Document Type'
                    defaultValue='EXCEL'
                  />
                </Box> */}
              <Box
                sx={{
                  marginTop: '5%',
                  display: 'flex',
                  gap: '15px',
                  justifyContent: 'flex-end'
                }}
              >
                <CustomButton
                  className='cancel'
                  category='Cancel'
                  variant='outlined'
                  onClick={() => {
                    setDrawer(false);
                    mailClearErrors('email');
                  }}
                />
                <CustomButton
                  className='saveChanges'
                  category={'Send Mail'}
                  loading={isLoading}
                  type='submit'
                />
              </Box>
            </Box>
          </Box>
        </Dialog>
      )}
    </Box>
  );
};

export default AutoGenerateView;
